import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface SituationModalProps {
  lotNom: string;
  numeroSuivant: number;
  onValider: (situation: {
    numero: number;
    date: string;
    montantCumulatif: number;
    pourcentageAvancement?: number;
    commentaire?: string;
  }) => void;
  onFermer: () => void;
}

const SituationModal: React.FC<SituationModalProps> = ({
  lotNom,
  numeroSuivant,
  onValider,
  onFermer,
}) => {
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [montant, setMontant] = useState('');
  const [pourcentage, setPourcentage] = useState('');
  const [commentaire, setCommentaire] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const montantNum = parseFloat(montant.replace(/\s/g, '').replace(',', '.'));
    if (isNaN(montantNum) || montantNum <= 0) return;

    onValider({
      numero: numeroSuivant,
      date,
      montantCumulatif: montantNum,
      pourcentageAvancement: pourcentage ? parseInt(pourcentage) : undefined,
      commentaire: commentaire || undefined,
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Nouvelle situation</h3>
            <p className="text-sm text-gray-500">{lotNom} - Situation n°{numeroSuivant}</p>
          </div>
          <button
            onClick={onFermer}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Montant cumulatif (€)
            </label>
            <input
              type="text"
              value={montant}
              onChange={(e) => setMontant(e.target.value)}
              placeholder="ex : 250 000"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              % avancement (optionnel)
            </label>
            <input
              type="number"
              min="0"
              max="100"
              value={pourcentage}
              onChange={(e) => setPourcentage(e.target.value)}
              placeholder="ex : 45"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Commentaire (optionnel)
            </label>
            <textarea
              value={commentaire}
              onChange={(e) => setCommentaire(e.target.value)}
              rows={2}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
              placeholder="Description de l'avancement..."
            />
          </div>

          <div className="flex justify-end space-x-3 pt-2">
            <button
              type="button"
              onClick={onFermer}
              className="border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 rounded-lg px-4 py-2 text-sm font-medium transition-colors"
            >
              Annuler
            </button>
            <button
              type="submit"
              className="bg-violet-600 text-white hover:bg-violet-700 rounded-lg px-4 py-2 text-sm font-medium transition-colors"
            >
              Valider la situation
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SituationModal;
